var exports = {
  "k": "x2b2fbebb--14b1e7--container",
};

module.exports = exports;
